module.exports = __webpack_public_path__ + "../static/img/base_server.c97d0b79.png";